import { RootState } from 'store/rootReducer';

export const getOneClickPaymentStatus = (state: RootState) => {
  return state.oneClickPayment.status;
};

export const getOneClickPaymentCardToken = (state: RootState) => {
  return state.oneClickPayment.cardToken;
};

export const getOneClickPaymentDeclineType = (state: RootState) => {
  return state.oneClickPayment.declineType;
};

export const getOneClickPaymentVerifyUrl = (state: RootState) => {
  return state.oneClickPayment.verifyUrl;
};

export const getOneClickPaymentOrderId = (state: RootState) => {
  return state.oneClickPayment.orderId;
};
